import React, { Component } from 'react';
import { Field } from 'redux-form';
import {
    renderFieldCpf,
    renderField,
    apenasNumero,
    required,
    apenasLetra,
    minTamanhoNome,
    maxTamanhoNome,
    validarRG,
    telefoneValidation,
    renderFieldDataNascimento,
    validarCpfCnpjInformado,
    renderFieldCheck,
    maxValueMonetario,
    minValueMonetario,
    renderFieldMonetarioFormulario,
    renderFieldText
} from '../../util/inputs';

export default class PassageiroAgendamentoViagem extends Component {

    buscarUsuarioPorCpf(event) {
        const cpf = apenasNumero(event.target.value);
        if (cpf.length === 11) {
            this.props.buscarPassageiroPorCpf(cpf)
                .then((resp) => {
                    if (resp.payload.status === 200) {
                        this.props.preencherValoresPassageiro(resp.payload.data, event.target.id.replace(/[^\d]+/g, ''));
                    }
                })
        }
    }

    removerPassageiro(e, passageiro) {
        e.preventDefault();
        this.props.removerPassageiro(passageiro.assento, passageiro.fileira);
    }

    render() {
        const style = {
            backgroundColor: 'rgb(250, 141, 66)',
            borderRadius: '8px',
            padding: '8px',
            width: '35px',
            textAlign: 'center',
            border: '1px solid rgb(250, 141, 66)'
        }

        const { passageiro } = this.props;

        return (
            <div className="card mb-2 p-2" key={`passageiro${passageiro.poltronaId}`}>
                <div className="card-header" style={{ background: 'transparent', border: 'none' }}>                    
                    <i className="material-icons nav-icon float-right" style={{ cursor: 'pointer', color: 'red' }} 
                        title='Remover'
                        onClick={(e) => this.removerPassageiro(e, passageiro)}>&#xe872;</i>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-9 col-md-9 mb-2">
                        <strong style={style}>{passageiro.numeroPoltrona}</strong>
                    </div>
                    <div className="col-12 col-md-4 col-sm-4">
                        <Field name={`cpfPassageiro${passageiro.poltronaId}`} type="text" component={renderFieldCpf} label='Número do CPF'
                            validate={[validarCpfCnpjInformado]}
                            css="form-control" onBlur={e => this.buscarUsuarioPorCpf(e)} />
                    </div>
                    <div className="col-12 col-md-8 col-sm-8">
                        <Field name={`nomePassageiro${passageiro.poltronaId}`} type="text" component={renderField} minLength='2' label='Nome completo'
                            validate={[required, apenasLetra, minTamanhoNome, maxTamanhoNome]}
                            css="form-control" readOnly={false} />
                    </div>
                </div>
                <div className="form-row mt-1 mb-2">
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name={`rgPassegeiro${passageiro.poltronaId}`} type="text" max={22} component={renderField}
                            label='Número do RG'
                            validate={[required, validarRG]}
                            css="form-control" />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name={`dtNascimento${passageiro.poltronaId}`} type="text" max={10} component={renderFieldDataNascimento}
                            label='Data de nascimento'
                            validate={[required]}
                            css="form-control" />
                    </div>
                    <div className="col-12 col-sm-5 col-md-5">
                        <Field name={`telefone${passageiro.poltronaId}`} type="text" component={renderField}
                            validate={[telefoneValidation, required]}
                            css="form-control col-md-5" label="Telefone" />
                    </div>

                </div>
                <div className="form-row mt-2">
                    <div className="form-check form-check-inline">
                        <Field name={`cartao${passageiro.poltronaId}`} type="checkbox" component={renderFieldCheck} label="Cartão"
                            css="form-check-input" readOnly={false} className="form-check-input"
                            onChange={(e) => this.props.handleCkeckCartao(e.target.id.replace(/[^\d]+/g, ''))}
                        />

                        <Field name={`dinheiro${passageiro.poltronaId}`} type="checkbox" component={renderFieldCheck} label="Dinheiro"
                            css="form-check-input" readOnly={false} className="form-check-input"
                            onChange={(e) => this.props.handleCheckDinheiro(e.target.id.replace(/[^\d]+/g, ''))}
                        />

                        <Field name={`pix${passageiro.poltronaId}`} type="checkbox" component={renderFieldCheck} label="PIX"
                            css="form-check-input" readOnly={false} className="form-check-input"
                            onChange={(e) => this.props.handleCheckPix(e.target.id.replace(/[^\d]+/g, ''))}
                        />
                    </div>
                </div>
                {passageiro.dinheiro && <>
                    <div className="form-row">
                        <div className="col-12 col-sm-3 col-md-3">
                            <div className="form-group">
                                <Field name={`valorDinheiro${passageiro.poltronaId}`} type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                                    css="form-control col-md-10" label="Valor em dinheiro" />
                            </div>
                        </div>
                    </div>
                </>}
                {passageiro.cartao && <>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <h5><strong>Informações pagamento com cartão</strong></h5>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-3 col-md-3">
                            <div className="form-group">
                                <Field name={`valorCartao${passageiro.poltronaId}`} type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                                    css="form-control" label="Valor em cartão" />
                            </div>
                        </div>
                        <div className="col-12 col-sm-3 col-md-3">
                            <div className="form-group">
                                <Field name={`quantidadeParcelas${passageiro.poltronaId}`} type="text" component={renderFieldText}
                                    label="Quantidade de parcelas:"
                                    css="form-control" readOnly={false} />
                            </div>
                        </div>
                    </div></>}

                {passageiro.pix && <>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <h5><strong>Informações pagamento com PIX</strong></h5>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-3 col-md-3">
                            <div className="form-group">
                                <Field name={`valorPIX${passageiro.poltronaId}`} type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                                    css="form-control col-md-8" label="Valor em PIX" />
                            </div>
                        </div>
                    </div></>}



            </div>
        )
    }
}